module.exports = __webpack_public_path__ + "img/tg.10009c13.png";